<template>
  <v-flex shrink>
    <v-menu>
      <template #activator="{on}" lazy>
        <v-btn v-on="on" @click.stop class="ma-0" icon small>
          <v-icon small>more_vert</v-icon>
        </v-btn>
      </template>
      <v-list class="pa-0">
        <v-list-tile @click="setPivot">
          <v-list-tile-title>Seleccionar como pivote</v-list-tile-title>
        </v-list-tile>
        <v-list-tile v-if="!item.productId" @click="setIndividualQmpsCardVisible(true)">
          <v-list-tile-title>Crear QMP sólo con este item</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapMutations } = createNamespacedHelpers("matching");

export default {
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    brand() {
      return this.$route.params.brandName;
    },
    classificationId() {
      return this.$route.params.classificationId;
    }
  },
  methods: {
    ...mapMutations(["setIndividualQmpsCardVisible", "setPivotItems"]),
    setPivot() {
      this.setPivotItems([this.item]);
    }
  }
};
</script>